export const QUERY_KEYS = {
  AUXILIARY_BALANCE: "AUXILIARY_BALANCE",
  BALANCE: "BALANCE",
  BILL_CONSOLIDATIONS_FILTER: "BILL_CONSOLIDATIONS_FILTER",
  BILL_DOWNLOAD: "BILL_DOWNLOAD",
  BILLS: "BILLS",
  CHECK_USER_EMAIL: "CHECK_USER_EMAIL",
  CONSUMPTION: "CONSUMPTION",
  CONSUMPTION_GRAPH: "CONSUMPTION_GRAPH",
  CONTACT: "CONTACT",
  CONTRACT: "CONTRACT",
  CONTRACT_ADDRESSING_CODE_EDITION: "CONTRACT_ADDRESSING_CODE_EDITION",
  CUSTOMER: "CUSTOMER",
  CUSTOMERS_ALL_BY_GROUP: "CUSTOMERS_ALL_BY_GROUP",
  EXPORT_DATA_REQUEST: "EXPORT_DATA_REQUEST",
  EXPOSITION_POINT: "EXPOSITION_POINT",
  GROUP: "GROUP",
  GROUPS: "GROUPS",
  GROUP_DOCUMENTS: "GROUP_DOCUMENTS",
  LOGIN: "LOGIN",
  MAXIMAL_POWER: "MAXIMAL_POWER",
  METER_READING_CREATION: "METER_READING_CREATION",
  PASSWORD_RESET: "PASSWORD_RESET",
  PASSWORD_UPDATE: "PASSWORD_UPDATE",
  PASSWORD_UPDATE_AFTER_RESET: "PASSWORD_UPDATE_AFTER_RESET",
  PERIMETER_CONTRACTS_DATA: "PERIMETER_CONTRACTS_DATA",
  PERIMETER_CUSTOMERS_DATA: "PERIMETER_CUSTOMERS_DATA",
  PERIMETER_DATA: "PERIMETER_DATA",
  PERIMETER_EXPORT: "PERIMETER_EXPORT",
  PERIMETER_EXPORT_DOWNLOAD: "PERIMETER_EXPORT_DOWNLOAD",
  PERIMETER_EXPORT_GENERATION: "PERIMETER_EXPORT_GENERATION",
  PERIMETER_POD_DATA: "PERIMETER_POD_DATA",
  PERIMETER_SITES_DATA: "PERIMETER_SITES_DATA",
  POINTS_OF_DELIVERY_FILTER: "POINTS_OF_DELIVERY_FILTER",
  SITE: "SITE",
  SITES: "SITES",
  SITES_CONTACT: "SITES_CONTACT",
  TARIFF_SHIELDS_STATEMENT: "TARIFF_SHIELDS_STATEMENT",
  TECHNICAL_REQUEST: "TECHNICAL_REQUEST",
  TECHNICAL_REQUEST_CREATION: "TECHNICAL_REQUEST_CREATION",
  TECHNICAL_REQUESTS: "TECHNICAL_REQUESTS",
  TENANT_CONFIG: "TENANT_CONFIG",
  USER: "USER",
  USER_ADMIN_STATUS_EDITION: "USER_ADMIN_STATUS_EDITION",
  USER_AUTHORIZATIONS_EDITION: "USER_AUTHORIZATIONS_EDITION",
  USER_CREATION: "USER_CREATION",
  USER_DELETION: "USER_DELETION",
  USERNAME_EDITION: "USERNAME_EDITION",
  USERS: "USERS",
};
